import { Component, Input, OnInit } from '@angular/core';
import { IFormPaymentFee } from '../../models/credential/scenarioRequirementDefinition.model';

@Component({
  selector: 'requirement-fee-forms',
  templateUrl: './requirement-fee-forms.component.html',
  styleUrls: ['./requirement-fee-forms.component.scss'],
  standalone: false
})
export class RequirementFeeFormsComponent implements OnInit {
  @Input() formPaymentFees: IFormPaymentFee[] = [];
  ngOnInit(): void {}
}
